if (Shopify.derm_custom == undefined) Shopify.derm_custom = {};

Shopify.derm_custom.addToBagShopify = async function(evt, variantId, isSubscriptionOrder = false, disableRechargeVariant = false ){

  var btn = evt.target;

  if (btn != undefined){
    try{
      var btnTextUpdate = evt.target.querySelector('span');
      if (btn.classList.contains('is-pending')) return;
      btn.classList.add('is-pending');
      if (btn) {
      btn.textContent = "ADDED TO CART"
      }
      var btnTimeout = setTimeout(function(){
        btn.classList.remove('is-pending');
      },1000)
    }catch(err){console.error(err)}
  }

  return new Promise( async function(resolve,reject){

    try{
      var urlEncodedPayload='?id='+variantId.toString() + '&quantity=1&properties[_rechargeOrder]=' + isSubscriptionOrder.toString() + '&quantity=1&properties[_disableRechargeVariant]=' + disableRechargeVariant.toString();

     var jsonPayload = {
        id: variantId,
        quantity: 1,
        'properties[_rechargeOrder]': false
       }
      

      if (document.cookie.indexOf('fenixSSID') > -1){
        try{
          jsonPayload['properties[_fenix_sessionid]']= /fenixSSID=([^;]+);/.exec(document.cookie)[1]
          urlEncodedPayload += '&properties[_fenix_sessionid]=' + /fenixSSID=([^;]+);/.exec(document.cookie)[1]
        }catch(err){console.error(err)}
      }


      var xhr = new XMLHttpRequest();
      xhr.open('POST','/cart/add.js' + urlEncodedPayload,true)
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
      xhr.responseType = 'json';

      xhr.onerror = function(){
        clearTimeout(btnTimeout);
        if (btn != undefined){
          try{
            btn.classList.remove('is-pending');
          }catch(err){console.error(err)}
        }
        reject("error")
      }

      xhr.onload = function(){
        clearTimeout(btnTimeout);
        if (btn != undefined){
          try{
            btn.classList.remove('is-pending');
          }catch(err){console.error(err)}
        }
        if(xhr.status == 200){
          const addedItem = xhr.response;
          Shopify.derm_custom.updateShopifyCart();
          Shopify.derm_custom.updateCartSections({
            openNotification: true,
            itemKey: addedItem?.key || null,
            variantId: addedItem?.variant_id || variantId,
            source: 'custom-add',
          });
          if (window.location.pathname.indexOf('/cart') > -1) Shopify.derm_custom.refreshCartItemSection();
          resolve("product added successfully");
        }else{
          reject("error in adding product to cart");
        }
      }

      xhr.send(urlEncodedPayload);

    }catch(err){
      reject(err);
    }


  })

}

Shopify.derm_custom.addProductToBagShopify = async function (evt, variantId, isSubscriptionOrder = false, disableRechargeVariant = false) {
  const btn = evt.target;
  if (!handleButtonState(btn)) return;

  const formData = await createFormData(variantId, isSubscriptionOrder, disableRechargeVariant);

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  config.body = formData;

  try {
    const response = await fetch(routes.cart_add_url, config);
    const data = await response.json();
    handleResponse(data, btn, variantId);
  } catch (error) {
    handleError(error, btn);
  }

}

function handleButtonState(btn) {
  if (!btn) return false;

  try {
    const btnTextUpdate = btn.querySelector("span");
    if (btn.classList.contains("is-pending")) return false;

    btn.classList.add("is-pending");
    if (btnTextUpdate) {
      btnTextUpdate.textContent = "ADDED TO CART";
    }
  } catch (err) {
    console.error("Error handling the button:", err);
  }

  return true;
}

async function createFormData(variantId, isSubscriptionOrder, disableRechargeVariant) {
  const formData = new FormData();
  formData.append("form_type", "product");
  formData.append("utf8", "✓");
  formData.append("id", variantId);
  formData.append("quantity", "1");

  formData.append("properties[_rechargeOrder]", isSubscriptionOrder.toString());
  formData.append("properties[_disableRechargeVariant]", disableRechargeVariant.toString());


  const fenixCookieMatch = document.cookie.match(/fenixSSID=([^;]+)/);
  if (fenixCookieMatch) {
    try {
      formData.append("properties[_fenix_sessionid]", fenixCookieMatch[1]);
    } catch (err) {
      console.error("Error extracting 'fenixSSID':", err);
    }
  }

  return formData;
}


function handleResponse(data, btn, variantId) {
  clearButtonPendingState(btn);

  if (data.status) {
    console.error("Error adding product to cart:", data);
    return;
  }

  Shopify.derm_custom.updateShopifyCart();
  Shopify.derm_custom.updateCartSections({
    openNotification: true,
    itemKey: data.key || null,
    variantId: data.variant_id || variantId,
    quantity: data.quantity || 1,
    source: 'custom-product-add',
  });

  if (window.location.pathname.includes("/cart")) {
    Shopify.derm_custom.refreshCartItemSection();
  }
}

function handleError(error, btn) {
  clearButtonPendingState(btn);
  console.error("Error adding product to cart:", error);
}

function clearButtonPendingState(btn) {
  if (!btn) return;

  try {
    btn.classList.remove("is-pending");
  } catch (err) {
    console.error("Error clearing the button status:", err);
  }
}

Shopify.derm_custom.addProduct = async function(evt, variantId, isSubscriptionOrder = false ){

  var btn = evt.target;
  if (btn != undefined){
    try{
      var btnTextUpdate = evt.target.querySelector('span');
      if (btn.classList.contains('is-pending')) return;
      btn.classList.add('is-pending')
      if (btnTextUpdate) {
      btnTextUpdate.textContent = "ADDED TO CART"
      }
      var btnTimeout = setTimeout(function(){
        btn.classList.remove('is-pending');
      },5000)
    }catch(err){console.error(err)}
  }

sellingPlanId='';

   
  return new Promise( async function(resolve,reject){

    try{
      var urlEncodedPayload='?id='+variantId.toString() + '&quantity=1&properties[_rechargeOrder]=' + isSubscriptionOrder.toString() + '&selling_plan=' +  sellingPlanId.toString();
 
      
      var jsonPayload = {
        id: variantId,
        quantity: 1,
        'properties[_rechargeOrder]': false,
         'selling_plan': sellingPlanId
       
      }
      

      if (document.cookie.indexOf('fenixSSID') > -1){
        try{
          jsonPayload['properties[_fenix_sessionid]']= /fenixSSID=([^;]+);/.exec(document.cookie)[1]
          urlEncodedPayload += '&properties[_fenix_sessionid]=' + /fenixSSID=([^;]+);/.exec(document.cookie)[1]
        }catch(err){console.error(err)}
      }


      var xhr = new XMLHttpRequest();
      xhr.open('POST','/cart/add.js' + urlEncodedPayload,true)
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
      xhr.responseType = 'json';

      xhr.onerror = function(){
        clearTimeout(btnTimeout);
        if (btn != undefined){
          try{
            btn.classList.remove('is-pending');
          }catch(err){console.error(err)}
        }
        reject("error")
      }

      xhr.onload = function(){
        clearTimeout(btnTimeout);
        if (btn != undefined){
          try{
            btn.classList.remove('is-pending');
          }catch(err){console.error(err)}
        }
        if(xhr.status == 200){
          const addedItem = xhr.response;
          Shopify.derm_custom.updateShopifyCart();
          Shopify.derm_custom.updateCartSections({
            openNotification: true,
            itemKey: addedItem?.key || null,
            variantId: addedItem?.variant_id || variantId,
            source: 'legacy-product-add',
          });
          if (window.location.pathname.indexOf('/cart') > -1) Shopify.derm_custom.refreshCartItemSection();
          resolve("product added successfully");
        }else{
          reject("error in adding product to cart");
        }
      }

      xhr.send(urlEncodedPayload);


    }catch(err){
      reject(err);
    }


  })

}

Shopify.derm_custom.removeOneProductCart = async function(prodIdArray){
  
  return new Promise( async function(resolve,reject){
    
    try{

      items = {
          
        quantity: 0,
        id: prodIdArray

      }

      console.log("jsonPayload",items)
    
      var xhr = new XMLHttpRequest();
      xhr.open('POST','/cart/change.js',true)
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.responseType = 'json';

      xhr.send(JSON.stringify(items));

      xhr.onload = ()=>{
        if(xhr.status == 200){
          console.log('ELEMENT REVED TO CART');
          Shopify.derm_custom.updateShopifyCart();
          Shopify.derm_custom.updateCartSections();
          if (window.location.pathname.indexOf('/cart') > -1) Shopify.derm_custom.refreshCartItemSection();
         
        }else{

          reject("error in removing product from cart");
        }
      }

      xhr.onerror = function(){
        reject("error")
      }


    }catch(err){
      console.log("murio aqui")
      reject(err);
    }


  })
}

Shopify.derm_custom.removeOneProduct = async function(prodIdArray){
  
  return new Promise( async function(resolve,reject){
    
    try{

    var jsonPayload = {
      updates: {},
    }

    prodIdArray.forEach((variantId) => {
      jsonPayload.updates[variantId] = 0
    })
    
      var xhr = new XMLHttpRequest();
      xhr.open('POST','/cart/update.js',true)
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.responseType = 'json';

      xhr.onerror = function(){
        console.log("algo pasa mal")
        reject("error")
      }

      xhr.onload = ()=>{
        if(xhr.status == 200){
          resolve("product removed successfully");
        }else{
          console.log("trolleado ")
          reject("error in removing product from cart");
        }
      }

      xhr.send(JSON.stringify(jsonPayload));

    }catch(err){
      console.log("murio aqui")
      reject(err);
    }


})

}

Shopify.derm_custom.updateProductCart = async function(cantidad, plan, itemKey, isSubscriptionOrder = false ){

  const itemKeyID = itemKey.replace(":", "");;

  const loadOverlay = document.querySelectorAll(`.cart-item__${itemKeyID} .loading-overlay`);
  const overlayCartItems = document.querySelector('#main-cart-items');

  overlayCartItems.classList.add('loading--overlay');

  loadOverlay.forEach((element) => {
    element.classList.remove('hidden');
  });

  return new Promise( async function(resolve,reject){
    
    try{
      var jsonPayload = 
     {
        quantity: cantidad,
        id: itemKey,
        selling_plan: plan,
        properties:{
          _rechargeOrder: (plan != null).toString(),
          _disableRechargeVariant: isSubscriptionOrder.toString()
         }
        
      }

      if (document.cookie.indexOf('fenixSSID') > -1){
        try{
          jsonPayload['properties']['_fenix_sessionid']= /fenixSSID=([^;]+);/.exec(document.cookie)[1]
        }catch(err){console.error(err,"xd")}
      }
      
      var xhr = new XMLHttpRequest();
      xhr.open('POST','/cart/change.js',true)
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.responseType = 'json';

      xhr.send(JSON.stringify(jsonPayload));

      xhr.onload = function(){
        Shopify.derm_custom.updateShopifyCart();
        Shopify.derm_custom.updateCartSections();
        if (window.location.pathname.indexOf('/cart') > -1) Shopify.derm_custom.refreshCartItemSection();
        if(xhr.status == 200){
         resolve("product added successfully");
        }else{
          reject("error in adding product to cart");
        }
      }

      xhr.onerror = function(){
        reject("error")
      }

    }catch(err){
      console.log(err)
      reject(err);
    }
  })

}

Shopify.derm_custom.updateProduct = async function(cantidad,id,plan){

  return new Promise( async function(resolve,reject){
    
    try{
      let variantId = id

      let myplan = plan == 0 ? '&properties[_rechargeOrder]=false' : `&properties[_rechargeOrder]=true&selling_plan=${plan}`
      var urlEncodedPayload='?id='+variantId.toString() + `&quantity=${cantidad}${myplan}`;

      var jsonPayload = 
      plan == 0 ?
      {
        items: [
          {
            quantity: cantidad,
            id: variantId
          }
        ]
      }
      : 
      {
        items: [
          {
            quantity: cantidad,
            id: variantId,
            selling_plan: plan
          }
        ]
      }


      if (document.cookie.indexOf('fenixSSID') > -1){
        try{
          jsonPayload['properties[_fenix_sessionid]']= /fenixSSID=([^;]+);/.exec(document.cookie)[1]
          urlEncodedPayload += '&properties[_fenix_sessionid]=' + /fenixSSID=([^;]+);/.exec(document.cookie)[1]
        }catch(err){console.error(err,"xd")}
      }else{
        console.log("que onda")
      }


      var xhr = new XMLHttpRequest();
      xhr.open('POST','/cart/add.js' + urlEncodedPayload,true)
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
      xhr.responseType = 'text';

      xhr.onerror = function(){
        reject("error",err)
      }

      xhr.onload = async function(){
        if(xhr.status == 200){
          await Shopify.derm_custom.updateShopifyCart();
          Shopify.derm_custom.updateCartSections();
          if (window.location.pathname.indexOf('/cart') > -1) await Shopify.derm_custom.refreshCartItemSection();

          resolve("product added successfully");
        }else{
          console.log("algo anda mal xd")
          reject("error in adding product to cart");
        }
      }

      xhr.send(urlEncodedPayload);

    }catch(err){
      console.log(err)
      reject(err);
    }


  })

}

Shopify.derm_custom.addToBagShopifyArray = async function(prodIdArray, isCouponGift = false, evt = null, disableBtn = false){
    console.log("addToBagShopifyArray")

    var btn = evt?.target?.closest('button') ?? evt?.target;
    if (btn != undefined){
      try{
        var btnTextUpdate = btn.querySelector('span');
        if (btn.classList.contains('is-pending')) return;
        btn.classList.add('is-pending')
        if (btnTextUpdate) {
        btnTextUpdate.textContent = "ADDED TO CART"
        }
        var btnTimeout = setTimeout(function(){
          btn.classList.remove('is-pending');
        },5000)
      }catch(err){console.error(err)}
    }

    return new Promise( async function(resolve,reject){

      var jsonPayload = {
        items: [],
        properties: {
          _rechargeOrder: false
        }
      }

      prodIdArray.forEach((variantId) => {

        var itemPayload = {
            id: variantId,
            quantity: 1
        }
       if ( isCouponGift && Shopify.derm_custom.discts?.lastDscApplied == undefined) Shopify.derm_custom.discts.lastDscApplied = '';
        
        if (isCouponGift){
          itemPayload.properties = {
             _isCouponGift: true,
            _relatedCodeHash: Shopify.derm_custom.discts.lastDscApplied
          }
        }

        jsonPayload.items.push(itemPayload)
      })


      if (document.cookie.indexOf('fenixSSID') > -1){
        try{
          jsonPayload.properties._fenix_sessionid= /fenixSSID=([^;]+);/.exec(document.cookie)[1]
          if (jsonPayload.properties._fenix_sessionid == ''){
            jsonPayload.properties._fenix_sessionid=0;
          }

        }catch(err){console.error(err)}
      }else{
        jsonPayload.properties._fenix_sessionid=0;
      }

      try{

        var xhr = new XMLHttpRequest();
        xhr.open('POST','/cart/add.js',true)
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.responseType = 'json';

        xhr.onerror = function(err){
          clearTimeout(btnTimeout);
          if (btn != undefined){
            try{
              btn.classList.remove('is-pending');
            }catch(err){console.error(err)}
          }
          reject("error",err)
        }

        
        xhr.onload = (res)=>{
          clearTimeout(btnTimeout);
          if (btn){
            try{
              btn.classList.remove('is-pending');
            }catch(err){console.error(err)}
          }
          if(xhr.status == 200){
            const addedItems = Array.isArray(xhr.response?.items) ? xhr.response.items : [];
            const primaryVariantId = prodIdArray[0] || null;
            const primaryItem = addedItems.find((item) => String(item.variant_id || item.id) === String(primaryVariantId)) || addedItems[0];
            const itemKeys = [...new Set(addedItems.map((item) => item.key).filter(Boolean))];
            const variantIds = [...new Set([
              ...addedItems.map((item) => item.variant_id || item.id),
              ...prodIdArray,
            ].filter(Boolean))];
            const addedItemCount = addedItems.length
              ? addedItems.reduce((count, item) => count + (Number(item.quantity) || 1), 0)
              : prodIdArray.length;
            const addedTotal = addedItems.length
              ? addedItems.reduce((total, item) => {
                  const linePrice = Number(item.final_line_price ?? item.line_price);
                  if (Number.isFinite(linePrice)) return total + linePrice;

                  const unitPrice = Number(item.final_price ?? item.price);
                  return total + (Number.isFinite(unitPrice) ? unitPrice * (Number(item.quantity) || 1) : 0);
                }, 0)
              : null;
            const shouldOpenNotification = !isCouponGift && Boolean(evt);
            Shopify.derm_custom.updateShopifyCart();
            Shopify.derm_custom.updateCartSections({
              openNotification: shouldOpenNotification,
              itemKey: primaryItem?.key || null,
              variantId: primaryItem?.variant_id || primaryVariantId,
              itemKeys,
              variantIds,
              addedItemCount,
              addedTotal,
              source: shouldOpenNotification ? 'customer-multi-add' : 'gift-or-sample-add',
            });
            if (window.location.pathname.indexOf('/cart') > -1) Shopify.derm_custom.refreshCartItemSection();
            console.log("product added successfully")
            if (disableBtn && btn){
              btn.disabled = true;
            }
            resolve("product added successfully");
          }else{
            reject("error in adding product to cart");
          }
        }

        xhr.send(JSON.stringify(jsonPayload));


      }catch(err){
        reject(err);
      }


  })

}

function getChangeCart() {
  
  if (typeof Shopify.derm_custom.initializeThreshold === 'function' && window.location.pathname.includes('/cart')) {
      Shopify.derm_custom.initializeThreshold();
    }

  var changeItemCart = window.localStorage.getItem('changeItemCart');

  var resetItemValue = window.localStorage.getItem('resetItemValue');
  console.log('resetItemValue', resetItemValue)
  if (resetItemValue == 'true') {
    if(changeItemCart){
      document.getElementById("modal-purchase-box").classList.remove("is-hiddden--modal");
      window.localStorage.removeItem('changeItemCart');
      window.localStorage.removeItem('resetItemValue');
      setTimeout(function(){ 
        document.getElementById("modal-purchase-box").classList.add("is-hiddden--modal");
      }, 7000);
    
    }

  }
}

Shopify.derm_custom.removeItemArrayCart = async function(prodIdArray){

  return new Promise( async function(resolve,reject){

    var jsonPayload = {
      updates: {},
    }

    prodIdArray.forEach((variantId) => {
      jsonPayload.updates[variantId] = 0
    })


    try{

      var xhr = new XMLHttpRequest();
      xhr.open('POST','/cart/update.js',true)
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.responseType = 'json';

      xhr.onerror = function(){

        reject("error")
      }

      xhr.onload = ()=>{
        if(xhr.status == 200){
          resolve("product removed successfully");
          Shopify.derm_custom.updateCartSections();
          if (window.location.pathname.indexOf('/cart') > -1) Shopify.derm_custom.refreshCartItemSection();
        }else{
          reject("error in removing product from cart");
        }
      }

      xhr.send(JSON.stringify(jsonPayload));


    }catch(err){
      reject(err);
    }


})

}

Shopify.derm_custom.trackingAddToCart = async function(){
  var xhr = new XMLHttpRequest();
  xhr.open('GET','/cart.js',true)
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.responseType = 'json';

  xhr.onload = function() {
    var cart = xhr.response

    const payload = cart.items;
    const items = payload.map(item => ({
      Name: item.product_title,
      Price: item.price / 100, 
      URL: window.location.origin + item.url,
      ImageURL: item.image,
      Quantity: item.quantity
    }));

    klaviyo.track( 'Add to Cart', { items });
  }

  xhr.send();
}

Shopify.derm_custom.updateShopifyCart = async function(){

  setTimeout(() => {
    getChangeCart();
  }, 500);

  var xhr = new XMLHttpRequest();
  xhr.open('GET','/cart.js',true)
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.responseType = 'json';

  xhr.onload = function() {
    var cart = xhr.response

    var countBubble;
    let total_amount = cart.total_price / 100
    const collection = document.getElementsByClassName("threshold-input-value")
    for(var i = 0; i < collection.length ; i++){
      let e = collection[i]
      if(total_amount >= parseInt(e.value)){
        if(i == 0){
          document.getElementById("first-bar").classList.add("completed")
        }
        document.getElementById("step-"+i).classList.add("completed")
        document.getElementById("n-bar-"+i).classList.add("completed")
        document.getElementById("circle-"+i).classList.add("active")
        document.getElementById("product-"+i).classList.add("active")
        if(i == collection.length-1){
          document.getElementsByClassName("threshold-message-done")[0].style.display = "block"
          document.getElementsByClassName("threshold-message")[0].style.display = "none"
        }
      }else{
        if(i == 0){
          document.getElementById("first-bar").classList.remove("completed")
        }

        document.getElementById("step-"+i).classList.remove("completed")
        document.getElementById("n-bar-"+i).classList.remove("completed")
        document.getElementById("circle-"+i).classList.remove("active")
        document.getElementById("product-"+i).classList.remove("active")

        document.getElementById("circle-"+i).classList.remove("active")
        document.getElementById("product-"+i).classList.remove("active")
        document.getElementsByClassName("threshold-message-done")[0].style.display = "none"
        document.getElementsByClassName("threshold-message")[0].style.display = "block"
        document.getElementsByClassName("threshold-amount")[0].innerHTML = "$"+ (parseInt(e.value)-total_amount).toString()
        break;
      }

    }

    if (document.querySelector('.cart-count-bubble') == undefined || document.querySelector('.cart-count-bubble') == null){
      if (cart.item_count < 1) return;
      countBubble = document.createElement('div');
      countBubble.classList.add('cart-count-bubble');
      var hiddenString;
      if (cart.item_count > 1){
        hiddenString = cart.item_count + ' items';
      }else{
        hiddenString = cart.item_count + ' item';
      }
      countBubble.innerHTML= '<span aria-hidden="true">' + cart.item_count + '</span><span class="visually-hidden">'+hiddenString + '</span>';
      document.getElementById('cart-icon-bubble').appendChild(countBubble);
    }else{

      var countBubble = document.querySelector('.cart-count-bubble');

      if (cart.item_count < 1){
        countBubble.remove();
        return;
      }

      document.querySelectorAll('.cart-count-bubble span').forEach(function(spanEl,spanIndex){
        if (spanIndex == 0){
          spanEl.innerHTML = cart.item_count;
        }
        if (spanIndex == 1){
          if (cart.item_count > 1){
            spanEl.innerHTML = cart.item_count + ' items';
          }else{
            spanEl.innerHTML = cart.item_count + ' item';
          }
        }
      })
    }
    try{

      document.getElementById('shopify-section-header').classList.remove('shopify-section-header-hidden');
    }catch(err){console.error(err)}




  };

  xhr.send();

}

Shopify.derm_custom.refreshCartItemSection = async function(){

  Shopify.derm_custom.updateShopifyCart();
  const cartItemSection = document.querySelector('div.shopify-section[id*="__cart-items"]');
  const cartItemSectionId = cartItemSection.id.replace('shopify-section-','')

  const cartGiftSection = document.querySelector('div.shopify-section[id*="__gifts"]');
  const cartGiftSectionId = cartGiftSection.id.replace('shopify-section-','')

  cartItemSection.style.minHeight = document.querySelector('div.shopify-section[id*="__cart-items"]').offsetHeight + 'px';
  fetch(window.location.pathname + "?sections="+cartItemSectionId)
  .then(response => response.json())
  .then(data => {
    const domParser = (new DOMParser).parseFromString(data[cartItemSectionId],'text/html');



    document.querySelector('div.shopify-section[id*="__cart-items"').innerHTML = domParser.getElementById('shopify-section-'+cartItemSectionId).innerHTML;

    const samplesToRemoveEl = domParser.getElementById('free_samples_remove');

    let samplesToRemove = ''



    if (samplesToRemoveEl != undefined && samplesToRemoveEl != null){
      samplesToRemove = samplesToRemoveEl.dataset.idsToRemove;
    }

    console.log('sdsToRemove', samplesToRemove);

    const cartGiftSection = document.querySelector('div.shopify-section[id*="__gifts"]');
    const cartGiftSectionId = cartGiftSection.id.replace('shopify-section-','')

    fetch(window.location.pathname + "?sections="+cartGiftSectionId)
    .then(giftResponse => giftResponse.json())
    .then(giftData => {
      const giftDomParser = (new DOMParser).parseFromString(giftData[cartGiftSectionId],'text/html');

      document.querySelector('div.shopify-section[id*="__gifts"').innerHTML = giftDomParser.getElementById('shopify-section-'+cartGiftSectionId).innerHTML;

      const giftsToRemoveEl = giftDomParser.getElementById('gift_ids_remove');

      var giftsToRemove = ''
      if (giftsToRemoveEl != undefined && giftsToRemoveEl != null){
        giftsToRemove = giftsToRemoveEl.dataset.giftIdsRemove;
      }


      const itemsToRemoveRaw = samplesToRemove.split(',').concat(giftsToRemove.split(','));


      function onlyUnique(value, index, self) {
        if (value == '') {
          return false;
        }else{
          return self.indexOf(value) === index;
        }
      }

      const itemsToRemove = itemsToRemoveRaw.filter(onlyUnique)


      if (itemsToRemove.length > 0){
        Shopify.derm_custom.removeItemArrayCart(itemsToRemove)
      }else{
        const giftsAvailEl = giftDomParser.getElementById('avail_gifts');

        try{

          const giftsAvail = JSON.parse(giftsAvailEl.dataset.giftsAvail.replace(/_%22_/g,'"'));

          Shopify.derm_custom.discts.blocks = giftsAvail;
        }catch(err){
          console.error(err);
          Shopify.derm_custom.discts.blocks = {};
        }
      }


    })



    var timeoutCounter = 0;
    var fenixInterval = setInterval(function(){

      try{

      if (document.querySelector('#main-cart-footer div.fenix-delivery-estimate-cart') != undefined && document.querySelector('#main-cart-footer div.fenix-delivery-estimate-cart').innerHTML != ''){
          clearInterval(fenixInterval);
          document.querySelector('div.cloned_fenix_message').innerHTML = document.querySelector('#main-cart-footer div.fenix-delivery-estimate-cart').outerHTML
          cartItemSection.style.minHeight = 0;
        }
        timeoutCounter++;
        if (timeoutCounter > 30){
          cartItemSection.style.minHeight = 0;
        }
        if (timeoutCounter > 50){
          clearInterval(fenixInterval);
        }
      }catch(err){console.error(err)}

    },100);

Shopify.derm_custom.initializeSwiper();
    
  });

}

Shopify.derm_custom.selectVariantInCarousel = async function(productId, indexInCard){
  document.querySelectorAll('.card-wrapper[data-prod-id="' + productId + '"] .card__content.with_variant').forEach(function(productCard){
    productCard.dataset.selectedVariant=indexInCard
  })
}

Shopify.derm_custom.chooseFreeSample = async function(evt, variantId){
  document.querySelector('div.free_samples_selector').classList.add('no-interactions');

  var btn = evt.target;


  if (btn.classList.contains('is-pending')) return;

  btn.classList.add('is-pending')

  Shopify.derm_custom.addToBagShopifyArray([variantId])
  .then(function(res){
    btn.classList.remove('is-pending');
  })
  .catch(function(err){
    btn.classList.remove('is-pending');
  })
}


Shopify.derm_custom.toggleSampleSelector = async function(){
  document.querySelector('div.free_samples_selector').classList.toggle('collapsed');
}

Shopify.derm_custom.emptyChangeRequest = async function(){

  return new Promise( async function(resolve,reject){

    var xhr = new XMLHttpRequest();
    xhr.open('POST','/cart/change',true)
    xhr.responseType = 'json';

    xhr.onerror = function(){
      reject("error")
    }

    xhr.onload = ()=>{
      if(xhr.status == 200){
        Shopify.derm_custom.updateShopifyCart();
        Shopify.derm_custom.updateCartSections();
        if (window.location.pathname.indexOf('/cart') > -1) Shopify.derm_custom.refreshCartItemSection();
        resolve("product added successfully");
      }else{
        reject("error in adding product to cart");
      }
    }

    xhr.send();
  })
}

Shopify.derm_custom.clearAllCart = async function(){
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  })
  .then(response => {
    if (response.ok) {
      Shopify.derm_custom.updateCartSections();
      if (window.location.pathname.includes("/cart")) {
        Shopify.derm_custom.refreshCartItemSection();
      }
    } else {
      console.error('Failed to clear cart');
    }
  })
  .catch(error => console.error('Error:', error));
}

Shopify.derm_custom.updateCartSections = async function(cartUpdate = null){
  const update = cartUpdate && typeof cartUpdate === 'object'
    ? {
        openNotification: cartUpdate.openNotification === true,
        itemKey: cartUpdate.itemKey || null,
        variantId: cartUpdate.variantId || null,
        itemKeys: Array.isArray(cartUpdate.itemKeys) ? cartUpdate.itemKeys.filter(Boolean) : [],
        variantIds: Array.isArray(cartUpdate.variantIds) ? cartUpdate.variantIds.filter(Boolean) : [],
        addedItemCount: Number(cartUpdate.addedItemCount) || 0,
        addedTotal: cartUpdate.addedTotal !== null
          && cartUpdate.addedTotal !== undefined
          && Number.isFinite(Number(cartUpdate.addedTotal))
            ? Number(cartUpdate.addedTotal)
            : null,
        quantity: cartUpdate.quantity || 1,
        source: cartUpdate.source || 'cart-update',
      }
    : {
        openNotification: cartUpdate !== null && cartUpdate !== undefined,
        itemKey: null,
        variantId: cartUpdate || null,
        itemKeys: [],
        variantIds: [],
        addedItemCount: 0,
        addedTotal: null,
        quantity: 1,
        source: 'legacy-cart-update',
      };

  const notification = document.querySelector('cart-notification');
  const carts = Array.from(document.querySelectorAll('cart-drawer, mini-cart'));

  if (notification) {
    if (update.openNotification || notification.isExpanded?.()) {
      carts.unshift(notification);
    } else {
      notification.markCartDirty?.();
    }
  }

  const enabledCarts = carts.filter((cart) => !cart.hasAttribute('disabled'));
  if (!enabledCarts.length) return;

  const sectionsById = new Map();
  enabledCarts.forEach((cart) => {
    cart.getSectionsToRender().forEach((section) => sectionsById.set(section.id, section));
  });
  if (!sectionsById.size) return;

  try {
    const response = await fetch(
      '/?sections=' + Array.from(sectionsById.keys()).join(',') + '&sections_url=' + encodeURIComponent(window.location.pathname)
    );
    if (!response.ok) throw new Error('Unable to refresh cart sections');

    const data = await response.json();
    data.cartUpdate = update;
    data.itemKey = update.itemKey;
    data.variantId = update.variantId;
    enabledCarts.forEach((cart) => cart.renderContents(data));
  } catch (error) {
    console.error('Unable to refresh cart sections', error);
  }
}

// Clarity Smart Event
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.atc_variant_button, .product-form__submit').forEach(function(button) {
      button.addEventListener('click', function () {
              if (button.hasAttribute('data-skin-phase-waitlist-trigger')) return;
              window.clarity('event', 'add_to_cart');
      });
  });
});
